export enum FIELD_CODE {
  JOB_TITLE = 'JOB_TITLE',
  TRADE_STATUS = 'TRADE_STATUS',
  PROJECT_SKILLED_TRADE = 'PROJECT_SKILLED_TRADE',
  LAST_4_SSN = 'LAST_4_SSN',
  SUPERVISOR_NAME = 'SUPERVISOR_NAME',
  SECTION_3_EMPLOYEE = 'SECTION_3_EMPLOYEE',
  SECTION_3_RESIDENT = 'SECTION_3_RESIDENT',
  DATE_OF_HIRE = 'DATE_OF_HIRE',
  ELIGIBLE_TO_WORK_IN_US = 'ELIGIBLE_TO_WORK_IN_US',
  YEARS_OF_EXPERIENCE = 'YEARS_OF_EXPERIENCE',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  HOURLY_RATE_PAY = 'HOURLY_RATE_PAY',
  LGBTQ = 'LGBTQ',
  HARD_HAT_NUMBER = 'HARD_HAT_NUMBER',
  REFERRED_BY_BUILDING_SKILLS_NY = 'REFERRED_BY_BUILDING_SKILLS_NY',
  LISTED_ON_NYCHA_LEASE = 'LISTED_ON_NYCHA_LEASE',
  SOC_JOB_TITLE = 'SOC_JOB_TITLE',
  STEP_STATUS = 'STEP_STATUS',
  LANGUAGE_TURNER_PROTOCOL = 'LANGUAGE_TURNER_PROTOCOL',
  SUPERVISOR_PHONE = 'SUPERVISOR_PHONE',
  PHONE_DATA_TYPE = 'PHONE_DATA_TYPE',
}
